import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import ShuffleMessage from '../Shared/ShuffleMessage/ShuffleMessage';

export const InProgressPublishContent = (props) => {
    const { messages } = props
    return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
            <img
                width={350}
                alt="Progress-Loader"
                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/new_publish_loader.gif`}
            />
            <ShuffleMessage
                data={messages || []}
                interval={4000}
            />
        </div>
    )
}

const InProgressPublishDialog = (props) => {
    return (
        <Dialog
        width={"75%"}
            height={"80%"}
        >
            <InProgressPublishContent {...props} />
        </Dialog>
    )
}

export default InProgressPublishDialog